module.exports = __webpack_public_path__ + "media/images/global/footer-logo-00b9be3a8b548c36cfea6c15f53eab18.png";